import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconWeibo$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconWeibo extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'dbcfb7ee1e5ecdacec8fc35e919047a7a95dc95d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '0e0503628cb20ad9de328a3b8da5aa66d3fb87de', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6cf1ebc66542ec25741b636c45876c419f1686d1', d: "M9.563 17.224c-2.98.296-5.554-1.053-5.747-3.008-.194-1.957 2.066-3.78 5.044-4.075 2.98-.296 5.553 1.053 5.745 3.008.196 1.957-2.064 3.782-5.042 4.075m5.958-6.495c-.253-.077-.427-.126-.296-.46.289-.722.319-1.345.005-1.792-.583-.835-2.183-.79-4.016-.023 0 0-.576.251-.427-.203.28-.907.239-1.664-.199-2.104-.993-.996-3.638.037-5.906 2.305C2.986 10.148 2 11.949 2 13.506c0 2.976 3.817 4.786 7.55 4.786 4.896 0 8.152-2.844 8.152-5.101.002-1.366-1.148-2.141-2.18-2.462m3.25-5.446a4.76 4.76 0 0 0-4.535-1.468.689.689 0 0 0 .288 1.346 3.386 3.386 0 0 1 3.932 4.356.688.688 0 0 0 1.311.425V9.94a4.75 4.75 0 0 0-.996-4.657", fill: "currentColor" }), h("path", { key: 'f8b3224dd420557d1f82561b3287ff251b42e52d', d: "M16.957 6.922a2.31 2.31 0 0 0-2.208-.713.592.592 0 1 0 .246 1.16 1.134 1.134 0 0 1 1.316 1.458.594.594 0 0 0 1.13.365 2.32 2.32 0 0 0-.484-2.27m-7.23 6.761c-.105.178-.336.263-.514.188-.18-.072-.234-.273-.132-.447.104-.174.325-.258.502-.189.178.065.243.266.144.447M8.775 14.9c-.288.459-.906.66-1.37.449-.458-.209-.594-.743-.306-1.192.286-.447.882-.646 1.344-.452.467.201.616.73.332 1.194m1.083-3.254c-1.418-.37-3.02.338-3.636 1.587-.628 1.274-.02 2.69 1.41 3.152 1.486.479 3.235-.256 3.843-1.63.601-1.346-.149-2.73-1.617-3.11", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-weibo", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-weibo"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-weibo":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconWeibo$1);
            }
            break;
    } });
}

const CosmosIconWeibo = CosmosIconWeibo$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconWeibo, defineCustomElement };
